/**
 * Converts FastAPI/Pydantic `response.data.detail` into plain text for alerts/UI.
 * `detail` may be a string, a single object with `msg`, or an array of validation errors.
 */
export function formatApiDetail(detail) {
  if (detail == null || detail === '') return '';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((item) => {
        if (!item) return '';
        if (typeof item === 'string') return item;
        if (typeof item.msg === 'string') return item.msg;
        return '';
      })
      .filter(Boolean);
    return parts.length ? parts.join('. ') : '';
  }
  if (typeof detail === 'object' && typeof detail.msg === 'string') return detail.msg;
  return '';
}
